import { useCallback } from "react";
import { Alert } from "react-bootstrap";
import { useAppDispatch, useTypedSelector } from "../../../app/store";
import { clearAlerts, selectErrorMessage, selectSuccessMessage } from "./commonAlertSlice";

const CommonAlert = () => {
    const dispatch = useAppDispatch();
    const errorMessage = useTypedSelector(selectErrorMessage);
    const successMessage = useTypedSelector(selectSuccessMessage);

    const handleClose = useCallback(() => {
        dispatch(clearAlerts());
    }, [dispatch]);

    const message = errorMessage || successMessage;
    if (!message) return null;

    const variant = errorMessage ? "danger" : "success";

    return (
        <Alert variant={variant} className="mt-3 text-start" onClose={handleClose} dismissible>
            {message.title && <Alert.Heading>{message.title}</Alert.Heading>}
            {Array.isArray(message.content) ? (
                message.content.map((item, index) => (
                    <p key={index} className="mb-0">
                        {item}
                    </p>
                ))
            ) : (
                <p className="mb-0">{message.content}</p>
            )}
        </Alert>
    );
};

export default CommonAlert;
